import {BaseBlock, theme} from "../../framework/js/core";

export class Environment extends BaseBlock {
  constructor(root) {
    super(root);
    
  }
}